(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('UsersService', UsersService);

    UsersService.$inject = ['API_URL', '$http', 'UtilService', 'GenerateURL'];

    function UsersService(API_URL, $http, UtilService, GenerateURL) {
        var usersService = {
            activate: activate,
            activityReport: activityReport,
            addClient: addClient,
            changeRoles: changeRoles,
            checkNewUsersPasswordValid: checkNewUsersPasswordValid,
            checkPasswordExpireDays: checkPasswordExpireDays,
            checkPasswordResetLink: checkPasswordResetLink,
            create: create,
            createNewUser: createNewUser,
            deactivate: deactivate,
            delete: deleteUser,
            hasReceivablesClients: hasReceivablesClients,
            findByEmail: findByEmail,
            get: get,
            getDetails: getDetails,
            getEmailsLike: getEmailsLike,
            getUserDates: getUserDates,
            getFirstActivationDate: getFirstActivationDate,
            getLastActivityDate: getLastActivityDate,
            getLastFailedLoginDate: getLastFailedLoginDate,
            getLastFailLoginDate: getLastFailLoginDate,
            getLastSuccessfulLoginDate: getLastSuccessfulLoginDate,
            getOnePagePdfConfiguration: getOnePagePdfConfiguration,
            isEmailUnique: isEmailUnique,
            list: list,
            listWithParams: listWithParams,
            isLocked: isLocked,
            postChanges: postChanges,
            getLanguage: getLanguage,
            removeAllClients: removeAllClients,
            removeClient: removeClient,
            requestResetOwnPassword: requestResetOwnPassword,
            resetOwnPassword: resetOwnPassword,
            resetPassword: resetPassword,
            setOnePagePdf: setOnePagePdf,
            hasDocumentsAccess: hasDocumentsAccess,
            unlockDocuments: unlockDocuments,
            lockDocuments: lockDocuments,
            unlock: unlock,
            lock: lock,
            usersReport: usersReport,
            getActivityReportURL: getActivityReportURL,
            getUsersReportURL: getUsersReportURL
        };

        return usersService;

        function get(email) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/search/getByEmailContainingIgnoreCase',
                params: { email: email.toLowerCase() }
            });
        }

        function list(filter) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers',
                params: UtilService.nullsToEmptyStrings(filter)
            });
        }

        function listWithParams(filter) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/findDhlUsers',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter))
            });
        }

        function getEmailsLike(email) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/search/findByEmailContainingIgnoreCase',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(email))
            });
        }

        function create(user) {
            return $http({
                method: 'PUT',
                url: API_URL + 'api/dhlUsers/create',
                data: user
            });
        }

        function deleteUser(UUID) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + UUID + '/delete'
            });
        }

        function hasReceivablesClients(UUID) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + UUID + '/hasReceivablesClients'
            });
        }

        function hasDocumentsAccess(id) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + id + '/hasDocumentsAccess'
            });
        }

        function unlockDocuments(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/unlockDocuments'
            });
        }

        function lockDocuments(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/lockDocuments'
            });
        }

        function unlock(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/unlock'
            });
        }

        function lock(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/lock'
            });
        }

        function resetPassword(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/resetPassword'
            });
        }

        function activate(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/activate'
            });
        }

        function deactivate(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/deactivate'
            });
        }

        function changeRoles(id, roles) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/roles/change',
                data: { 'roleNames': roles }
            });
        }

        function usersReport(filter) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/reports/users',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter)),
                responseType: 'arraybuffer'
            });
        }

        function activityReport(filter) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/reports/activity',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter)),
                responseType: 'arraybuffer'
            });
        }

        function addClient(userId, email, clientNumber) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + userId + '/clients/add',
                params: { email: email, clientNumber: clientNumber }
            });
        }

        function removeClient(userId, email, clientNumber) {
            return $http({
                method: 'DELETE',
                url: API_URL + 'api/dhlUsers/' + userId + '/clients/remove',
                params: { email: email, clientNumber: clientNumber }
            });
        }

        function removeAllClients(userId, email) {
            return $http({
                method: 'DELETE',
                url: API_URL + 'api/dhlUsers/' + userId + '/clients/removeAll',
                params: { email: email }
            });
        }

        function findByEmail(email) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/byEmail/' + email.toLowerCase()
            });
        }

        function postChanges(userId, language) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + userId + '/editLanguage',
                params: { language: language }
            });
        }

        function getLanguage(userId) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + userId + '/language'
            });
        }

        function getLastFailLoginDate(name) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/ediPartyUsersByName/' + name
            });
        }

        function setOnePagePdf(userId, onePagePdf) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + userId + '/PdfPagesShow/edit',
                params: { onePagePdf: onePagePdf }
            });
        }

        function getOnePagePdfConfiguration(userId) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + userId + '/getUserOnePagePdfConfiguration'
            });
        }

        function createNewUser(registerData) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/registerRequest',
                data: registerData
            });
        }

        function isEmailUnique(email) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/isUniqueEmail',
                params: { email: email.toLowerCase() }
            });
        }

        function getDetails(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/getFullDetails'
            });
        }

        function getUserDates(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/dates'
            });
        }

        function getFirstActivationDate(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/firstActivationDate'
            });
        }

        function getLastActivityDate(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/lastActivityDate'
            });
        }

        function getLastFailedLoginDate(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/lastFailedLoginDate'
            });
        }

        function getLastSuccessfulLoginDate(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/lastSuccessfulLoginDate',
                params: { id: uuid }
            });
        }

        function requestResetOwnPassword(email) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/requestResetOwnPasswordRequest',
                params: { email: email.toLowerCase() }
            });
        }

        function checkPasswordExpireDays(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/checkPasswordExpireDays'
            });
        }

        function checkNewUsersPasswordValid(password) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/isPasswordValid',
                data: password
            });
        }

        function checkPasswordResetLink(uuid, link) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/setPassword/' + link
            });
        }

        function resetOwnPassword(uuid, link, password) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + uuid + '/setPassword/' + link,
                data: password
            });
        }

        function isLocked(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/lock'
            });
        }

        function getUsersReportURL(filter) {
            var params = UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter));
            var baseURL = API_URL + 'api/dhlUsers/reports/users';

            return GenerateURL.generate(baseURL, params);
        }

        function getActivityReportURL(filter) {
            var params = UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter));
            var baseURL =  API_URL + 'api/dhlUsers/reports/activity';

            return GenerateURL.generate(baseURL, params);
        }
    }
})();
